import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import { InputFeedback } from './Common';
import {Field} from 'formik';

export default class RANumberFormater extends Component {
  render() {
    const { error } = this.props;
    return (
      <div>
        <Field
        className={"form-control"}
        component={NumberFormat}
        allowNegative={this.props.allowNegative || false}
        {...this.props}
        />
        {<InputFeedback error={error} />}
      </div>
    );
  }
}